import { EmailTemplateResult } from 'api/client-domain/email-template-service/email-template-service.types';
import FormDrawer from 'components/drawers/form-drawer/form-drawer.component';
import { IncDrawerType } from 'components/drawers/inc-drawer/inc-drawer.component';
import EmailTemplateForm from 'components/forms/email-template-form/email-template-form.component';
import { ReactNode, useCallback } from 'react';
import { Option } from 'util/multi-select';

export type EmailTemplateDrawerDataType = {
  template: Partial<EmailTemplateResult>;
  oneOff?: boolean;
  setFormFieldValue?: (option: Option) => void;
};

type EmailTemplateDrawerProps<T> = Omit<IncDrawerType<T>, 'data'> & {
  formMethods: any;
  submitHandler: (data: any) => void;
  title: ReactNode;
  submitButtonLabel: string;
  subtitle?: ReactNode;
};

const EmailTemplateDrawer = <T extends EmailTemplateDrawerDataType>({
  isOpen,
  close,
  formMethods,
  submitHandler,
  title,
  submitButtonLabel,
  subtitle,
}: EmailTemplateDrawerProps<T>) => {
  const cancel = useCallback(() => {
    formMethods.reset();
    close();
  }, [close, formMethods]);

  return (
    <FormDrawer
      title={title}
      open={isOpen}
      onClose={close}
      onValid={submitHandler}
      cancel={cancel}
      formMethods={formMethods}
      submitButtonLabel={submitButtonLabel}
      data-testid="EmailTemplateDrawer.FormDrawer"
      subtitle={subtitle}
    >
      <EmailTemplateForm />
    </FormDrawer>
  );
};

export default EmailTemplateDrawer;
